import { Endereco } from './Endereco';
import { BankData } from './BankData';
import { CompanyFinanceInformation } from './CompanyFinanceInformation';
import { CompanyEnterprise } from './CompanyEnterprise';
import { Suitability } from './Suitability';

export class Company {

    constructor() {
        this.endereco = new Endereco();
        this.bankAccounts = new BankData();
        this.financeInformation = new CompanyFinanceInformation();
        this.Enterprises = new Array<CompanyEnterprise>();
        this.Investments = new Suitability();
    }

    companyType: boolean;
    companyTypeDescription: string;
    economicActivityID: number;
    equity: number;
    monthlyRevenue: number;
    partners: any;
    representatives: any;
    emitters: any;
    relatedCompanies: any;
    attorneys: any;
    documents: any;
    registerOriginApplication: any;
    phoneAreaCode: string;
    phoneNumber: string;
    streetName: string;
    number: string;
    zipCode: string;
    complement: string;
    district: string;
    cityID: number;
    stateID: number;
    bankAccounts: BankData;

    photoID: string;
    profile: any;
    registrationStatus: any;
    cblc: string;
    birthDate: any;
    personType: any;
    personTypeDescripation: string;
    id: number;
    name: string;
    cpfcnpj: string;
    email: string;

    financeInformation: CompanyFinanceInformation;

    mainActivity: string;
    phone: string;

    endereco: Endereco;
    represents: any;
    terms: boolean;
    Investments: Suitability;
    Enterprises: Array<CompanyEnterprise>;
}